import React from 'react'
import { Modal } from "semantic-ui-react";
import './BasicModal.css'

export function BasicModal(props) {
  const { show, close, title, size, children, className } = props;

  return (
    <Modal className={className || "basic-modal"} open={show} onClose={close} size={size} closeIcon closeOnDimmerClick={false} >
      {title && <Modal.Header>{title}</Modal.Header>}
      <Modal.Content className="modal-content">{children}</Modal.Content>
    </Modal >
  )
}

BasicModal.defaultProps = {
  size: "tiny",
}